import { render, staticRenderFns } from "./lecture-dialog.vue?vue&type=template&id=084213d0&scoped=true"
import script from "./lecture-dialog.vue?vue&type=script&lang=js"
export * from "./lecture-dialog.vue?vue&type=script&lang=js"
import style0 from "./lecture-dialog.vue?vue&type=style&index=0&id=084213d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084213d0",
  null
  
)

export default component.exports